
import React from 'react';
import { Button } from '@/components/ui/button';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

interface PortfolioTabsHeaderProps {
  activeTab: string;
  formEdited: boolean;
  isMobile: boolean;
  handleCancel: () => void;
  handleSave: (e?: React.MouseEvent<HTMLButtonElement>) => void;
}

const PortfolioTabsHeader = ({
  activeTab,
  formEdited,
  isMobile,
  handleCancel,
  handleSave
}: PortfolioTabsHeaderProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-2">
      {/* Tabs menu */}
      <TabsList className={`bg-muted/50 ${isMobile ? 'w-full' : 'w-auto inline-flex'} rounded-full p-1`}>
        <TabsTrigger value="general" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
          General
        </TabsTrigger>
        <TabsTrigger value="billing" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
          Billing
        </TabsTrigger>
        <TabsTrigger value="users" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
          Members
        </TabsTrigger>
      </TabsList>
      
      {/* Show save/cancel buttons on desktop only for general tab */}
      {!isMobile && formEdited && activeTab === 'general' && (
        <div className="flex gap-2 justify-end mt-4 md:mt-0">
          <Button variant="outline" onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleSave}>Save Changes</Button>
        </div>
      )}
    </div>
  );
};

export default PortfolioTabsHeader;
